export default __webpack_public_path__ + "images/A2.d85dad5.png";